/**
 * Back one screen, or home when nothing of the app is behind the current
 * screen (it was opened by a link or in a new tab): back alone would do nothing
 * on native and leave the app on web. A screen with a better parent checks
 * `canGoBack()` itself, as package detail does.
 */
export function backOrHome({
  canGoBack,
  back,
  replace,
}: {
  canGoBack: () => boolean;
  back: () => void;
  replace: (path: string) => void;
}) {
  if (canGoBack()) back();
  else replace("/");
}
